import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { CreateTeamInput, TeamResponse } from '@orion/contracts';
import { api } from '../../../lib/api-client.js';

const KEY = ['admin-teams'];

export function useTeamsQuery() {
  return useQuery({ queryKey: KEY, queryFn: () => api.get<TeamResponse[]>('/admin/teams') });
}

export function useCreateTeam() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateTeamInput) => api.post<TeamResponse>('/admin/teams', input),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: KEY }),
  });
}

export function useDeleteTeam() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.delete<void>(`/admin/teams/${id}`),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: KEY }),
  });
}

/** Sends the complete desired member list — the backend diffs against the
 * previous one itself and only notifies/emails whoever was actually added
 * or removed. */
export function useUpdateTeamMembers() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, membershipIds }: { id: string; membershipIds: string[] }) =>
      api.patch<TeamResponse>(`/admin/teams/${id}/members`, { membershipIds }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: KEY }),
  });
}
